import request from "@/config/utils/request";

export function searchList(data) {
  return request({
    url: "/apis/ebs/org/listSearchMember1",
    method: "post",
    data
  });
}
// 是否需要选择部门和添加兼职
export function checkUserIdExsit(data) {
  return request({
    url: "/apis/ebs/user/checkUserIdExsit",
    method: "post",
    data
  });
}
